import React from 'react';
import { Button } from "@blueprintjs/core";

import InterludeResourcesViewer from '../ResourceViewer/Interlude';

class ConclusionMonitor extends React.Component {
    render() {
        const {
            sessionInstance,
            interludeDisplayed,
            session,
            onPrevInterlude,
            onFirstInterlude,
            onNextInterlude,
            onLastInterlude,
            isNextDisabled,
            isPrevDisabled
        } = this.props;

        return (
            <div className="interludes-wrapper animated fadeIn">
                <div className="row resources">
                    <InterludeResourcesViewer
                        instance={sessionInstance}
                        interludeDisplayed={interludeDisplayed}
                        isConclusion={true}
                    />
                </div>
                <div className="nav text-center">
                    <Button
                        icon='double-chevron-left'
                        onClick={onFirstInterlude}
                        disabled={isPrevDisabled()}
                        style={{ marginRight: '5px' }} />
                    <Button
                        icon='chevron-left'
                        onClick={onPrevInterlude}
                        disabled={isPrevDisabled()}
                        className="large-padding" />
                    <span className="pagination">
                        <span className="muted">
                            Conclusion
                        </span>
                        &nbsp;{sessionInstance.currentConclusion + 1}&nbsp;
                        <span className="muted">
                            of
                        </span>
                        &nbsp;{session.data.conclusions.length}
                    </span>
                    <Button
                        rightIcon='chevron-right'
                        onClick={onNextInterlude}
                        disabled={isNextDisabled()}
                        className="large-padding" />
                    <Button
                        rightIcon='double-chevron-right'
                        onClick={onLastInterlude}
                        disabled={isNextDisabled()}
                        style={{ marginLeft: '5px' }} />
                </div>
            </div>
        );
    }
}

export default ConclusionMonitor;